import React from "react"
import SessionOverview from "./session-overview.component"
import SmallInfo from "./small-info.component"

class CategoryInfo extends React.Component {
  render() {
    const {
      category,
      desc,
      photo,
      sessions,
      slug,
      showSessionInformation,
      animationDirection,
    } = this.props

    return (
      <div
        className="category-info"
        data-aos={animationDirection}
        data-aos-delay="100"
      >
        <div className="category-info__top">
          <div className="category-info__text">
            <h1 className="category-info__text--heading">{category}</h1>
            <p className="category-info__text--description">{desc}</p>

            <div className="category-info__time">
              {sessions.map(session => {
                return (
                  <SmallInfo
                    key={session.name}
                    name={session.timePST}
                    secondaryName={session.timeEST}
                    value={session.name}
                  />
                )
              })}
            </div>
          </div>

          <div className="category-info__image">
            <img src={`${slug}${photo}`} alt="" />
          </div>
        </div>

        <div className="category-info__bottom">
          {sessions.map(session => {
            return (
              <SessionOverview
                key={session.id}
                {...{
                  ...session,
                  slug: slug,
                  showSessionInformation: showSessionInformation,
                }}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

export default CategoryInfo
